import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss']
})
export class SliderComponent implements OnInit, AfterViewInit {
  @ViewChild('rangeElement') rangeElement: ElementRef;

  @Input() min: number = 0;
  @Input() max: number = 100;
  @Input() step: number = 1;

  @Input() minSelectable: number = undefined;
  @Input() maxSelectable: number = undefined;
  @Input() minText: string;
  @Input() maxText: string;

  @Input() meetId: string;

  _value: number = undefined;
  get value(): number {
    return this._value;
  }
  @Input() set value(value: number) {
    if (value < (this.minSelectable ?? this.min))
      this._value = this.minSelectable ?? this.min;
    else if (value > (this.maxSelectable ?? this.max))
      this._value = this.maxSelectable ?? this.max;
    else
      this._value = value;
    this.updateWebkitProcentage();
  }

  @Output() valueChange = new EventEmitter<number>();

  ngOnInit(): void {
    if (this._value == null)
      this.value = (this.min + this.max) / 2;
  }

  ngAfterViewInit(): void {
    this.updateWebkitProcentage();
    this.valueChange.emit(this.value);
  }

  updateWebkitProcentage() {
    if (!this.rangeElement?.nativeElement?.style)
      return;

    const percentage = ((this.value - this.min) / (this.max - this.min)) * 100;
    this.rangeElement.nativeElement.style.setProperty('--webkitProgressPercent', `${percentage}%`);
  }

  onSliderChange(event) {
    const inputValue = parseInt(event.target.value);
    const actualValue = this.value;

    if (inputValue != actualValue)
      event.target.value = actualValue;

    this.valueChange.emit(this.value);
  }
}
